// AUTO-GENERATED GraphQL Builder for ChecklistItem
import * as Builders from '../';
export class ChecklistItemBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  checklistSectionId(){ return this.add('checklistSectionId'); }
  weddingCardId(){ return this.add('weddingCardId'); }
  title(){ return this.add('title'); }
  categoryLabel(){ return this.add('categoryLabel'); }
  viaServiceCategoryId(){ return this.add('viaServiceCategoryId'); }
  isAutoComplete(){ return this.add('isAutoComplete'); }
  isDone(){ return this.add('isDone'); }
  sortOrder(){ return this.add('sortOrder'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  checklistSection(b?:(q:Builders.ChecklistSectionBuilder)=>void){
    if(this.depth>=5||this.v.has('checklistSection'))return this;
    this.v.add('checklistSection');
    const n=new Builders.ChecklistSectionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`checklistSection { ${inner} }`);
    return this;
  }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  viaServiceCategory(b?:(q:Builders.ServiceCategoryBuilder)=>void){
    if(this.depth>=5||this.v.has('viaServiceCategory'))return this;
    this.v.add('viaServiceCategory');
    const n=new Builders.ServiceCategoryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`viaServiceCategory { ${inner} }`);
    return this;
  }

  weddingCard(b?:(q:Builders.WeddingCardBuilder)=>void){
    if(this.depth>=5||this.v.has('weddingCard'))return this;
    this.v.add('weddingCard');
    const n=new Builders.WeddingCardBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`weddingCard { ${inner} }`);
    return this;
  }
}
